import React, {
  lazy,
  Suspense,
  useLayoutEffect,
  useState,
  useEffect,
} from "react";
import pageImg from "../images/pageImg.png";
import pageImgMobile from "../images/pageImgMobile.png";
import WaitlistPage from "./waitlistPage";
import NavigationBar from "./NavigationBar";
import Prices from "./Billing/Prices";
import circle1 from "../images/circle1.svg";
import circle2 from "../images/circle2.svg";

const pagesData = [
  {
    id: 0,
    imgSrc: pageImg,
  },
  {
    id: 1,
    imgSrc: pageImg,
  },
  {
    id: 2,
    imgSrc: pageImg,
  },
];

const mobilePagesData = [
  {
    id: 0,
    imgSrc: pageImgMobile,
  },
  {
    id: 1,
    imgSrc: pageImgMobile,
  },
  {
    id: 2,
    imgSrc: pageImgMobile,
  },
];

function FadeInSection(props) {
  const [isVisible, setVisible] = React.useState(true);
  const domRef = React.useRef();
  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => setVisible(entry.isIntersecting));
      },
      { rootMargin: "-41% 0px", threshold: 0.1 }
    );
    observer.observe(domRef.current);
    // return () => observer.unobserve(domRef.current);
    document.documentElement.style.setProperty("--background", "#fff");
  }, []);
  return (
    <div
      className={`fade-in-section ${isVisible ? "is-visible" : ""}`}
      ref={domRef}
    >
      {props.children}
    </div>
  );
}

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}

export default function LandingPage() {
  const [width, height] = useWindowSize();
  const data = width <= 1000 ? mobilePagesData : pagesData;
  useEffect(() => {
    document.documentElement.style.setProperty("--background", "#fff");
  });
  return (
    <React.Fragment>
      <NavigationBar />
      {data.map((page, key) => {
        return (
          <FadeInSection key={key}>
            <div
              className="waitlist-page-wrapper"
              id={key === 0 ? "topPage" : ""}
              key={key}
            >
              <Suspense fallback={<h1>Loading...</h1>}>
                <WaitlistPage {...page} num={key} />
              </Suspense>
            </div>
          </FadeInSection>
        );
      })}
      <FadeInSection>
        <Prices hideCircles />
      </FadeInSection>
      <span className="background-circles">
        <img src={circle1} className="circle1" />
        <img src={circle2} className="circle2" />
      </span>
    </React.Fragment>
  );
}
